import React from "react";
import { connect } from "react-redux";

import DeleteDialog from "./DeleteDialog";
import EditDialog from "./EditDialog";
import Modal from "../../Shared/Modal";
import ReplaceOrCancelDialog from "./ReplaceOrCancelDialog";

const OptionsDialog = ({
  open,
  handleClose,
  selectedAction,
  newManu,
  replacementManufacturer,
  featuredManufacturer: { selectedManufacturer },
}) => {
  //leaving edit functionality here but don't plan on using as of right now.
  //The edit component will have to be changed from featured product to manufacuturer if it is to be used in the future
  return (
    <Modal
      open={open}
      setOpen={() => handleClose()}
      component={selectedAction === "edit" && selectedManufacturer ? <EditDialog handleClose={handleClose} />
        : selectedAction === "delete" && selectedManufacturer ? <DeleteDialog handleClose={handleClose} />
          : selectedAction === 'replaceConfirm' ?
            <ReplaceOrCancelDialog newManu={newManu} replacementManufacturer={replacementManufacturer} handleClose={handleClose} />
          : null}
    />
  );
};

OptionsDialog.propTypes = {};

const mapStateToProps = (state) => ({
  featuredManufacturer: state.featuredManufacturer,
});

export default connect(mapStateToProps, {})(OptionsDialog);
